// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@keyframes shimmer-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.chart-shimmer {
  animation: shimmer-fade 0.5s ease-in;
}
.chart-shimmer__title {
  height: 24px;
  width: 65%;
  margin-bottom: 0.75rem;
}
.chart-shimmer__subtitle {
  height: 16px;
  width: 45%;
  margin-bottom: 1.5rem;
}
.chart-shimmer__content {
  display: flex;
  align-items: flex-end;
  justify-content: space-evenly;
  padding: 2rem 1rem 1rem;
  background: #f8f9fa;
  background: var(--color-background-secondary, #f8f9fa);
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-border, #e0e0e0);
  border-radius: 4px;
  gap: 0.5rem;
}
.chart-shimmer__bar {
  flex: 1 1;
  max-width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.chart-shimmer__bar .shimmer-line {
  width: 100%;
  border-radius: 4px 4px 0 0;
  min-height: 20px;
}
.chart-shimmer__label {
  height: 12px !important;
  width: 80% !important;
  border-radius: 2px !important;
}

.shimmer-line {
  background: linear-gradient(90deg, #e9ecef 25%, #f1f3f5 50%, #e9ecef 75%);
  background: linear-gradient(90deg, var(--color-background-tertiary, #e9ecef) 25%, var(--color-background-secondary, #f1f3f5) 50%, var(--color-background-tertiary, #e9ecef) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/ChatContentView/ChartShimmer/ChartShimmer.scss"],"names":[],"mappings":"AAAA;EACE;IACE,4BAAA;EACF;EACA;IACE,2BAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE,oCAAA;AADF;AAGE;EACE,YAAA;EACA,UAAA;EACA,sBAAA;AADJ;AAIE;EACE,YAAA;EACA,UAAA;EACA,qBAAA;AAFJ;AAKE;EACE,aAAA;EACA,qBAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EAAA,sDAAA;EACA,yBAAA;EAAA,8CAAA;EACA,kBAAA;EACA,WAAA;AAHJ;AAME;EACE,SAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAJJ;AAMI;EACE,WAAA;EACA,0BAAA;EACA,gBAAA;AAJN;AAQE;EACE,uBAAA;EACA,qBAAA;EACA,6BAAA;AANJ;;AAUA;EACE,yEAAA;EAAA,gLAAA;EAMA,0BAAA;EACA,gCAAA;EACA,kBAAA;AAZF","sourcesContent":["@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes shimmer-fade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.chart-shimmer {\n  animation: shimmer-fade 0.5s ease-in;\n  \n  &__title {\n    height: 24px;\n    width: 65%;\n    margin-bottom: 0.75rem;\n  }\n  \n  &__subtitle {\n    height: 16px;\n    width: 45%;\n    margin-bottom: 1.5rem;\n  }\n  \n  &__content {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-evenly;\n    padding: 2rem 1rem 1rem;\n    background: var(--color-background-secondary, #f8f9fa);\n    border: 1px solid var(--color-border, #e0e0e0);\n    border-radius: 4px;\n    gap: 0.5rem;\n  }\n  \n  &__bar {\n    flex: 1;\n    max-width: 80px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n    \n    .shimmer-line {\n      width: 100%;\n      border-radius: 4px 4px 0 0;\n      min-height: 20px;\n    }\n  }\n  \n  &__label {\n    height: 12px !important;\n    width: 80% !important;\n    border-radius: 2px !important;\n  }\n}\n\n.shimmer-line {\n  background: linear-gradient(\n    90deg,\n    var(--color-background-tertiary, #e9ecef) 25%,\n    var(--color-background-secondary, #f1f3f5) 50%,\n    var(--color-background-tertiary, #e9ecef) 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
